<script>

export default {

  name: 'ChildrenList',

  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
      default: 'name',
    },
    children: {
      required: true,
      type: Array,
    },
    hideAdd: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  methods: {
    show(child) {
      this.$emit('show', child)
    },
  },
};

</script>

<template>
  <div class="h-auto">
    <div class="rounded bg-grey-light p-2">
      <div class="flex justify-between bg-grey-dark rounded-lg p-2">
        <h3 class="text-xl font-semibold">
          {{ name }}
        </h3>
      </div>
      <div class="text-sm mt-2">

        <button type="button" v-for="child in children"
                class="flex flex-row w-full font-semibold text-left bg-grey-dark p-2 rounded mt-1 border-b border-grey cursor-pointer hover:bg-grey hover:border-blue"
                @click="show(child)">
          {{ child[label] }}
        </button>

        <button type="button" class="w-full text-left my-2 hover:text-blue" v-if="!hideAdd"
                @click="show(null)">
          Add {{ name }}
        </button>
      </div>
    </div>
  </div>
</template>
